<template>
  <div style="display: flex; align-items: center; width: 100%;">
    <el-input 
      :placeholder="placeholder" 
      v-model="innerValue" 
      class="input-with-select" 
      :disabled="disabled"
      clearable
      style="flex: 1;"
    >
      <el-upload
          slot="append"
          ref="fileUpload"
          :auto-upload="true"
          :show-file-list="false"
          :file-list="uploadFileList"
          :limit="1"
          :http-request="handleUploadFile"
      >
        <el-button slot="trigger" size="small" type="primary" :loading="uploading" icon="el-icon-upload">{{buttonText}}</el-button>
      </el-upload>
    </el-input>

  </div>
</template>

<script>
/**
 * 文件上传链接选择器
 * @author PeterLee
 * @since 2026-03-04
 */
import {uploadOssFile} from "@/api/dataApi";
import {Message} from 'element-ui';

export default {
  name: "FileLinkUploadSelect",
  //设置v-model绑定对象和自动更新响应方法
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: String,
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请输入文件路径或上传文件"
    },
    buttonText: {
      type: String,
      // 可以为“文件上传”字样
      default: ""
    },
    objectKeyPrefix: {
      type: String,
      default: "fileUpload"
    }
  },
  data() {
    return {
      uploadFileList: [],
      uploading: false,
      currentUploadFile: null
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleUploadFile(options) {
      if (!options.file) {
        Message.warning('请选择要上传的文件');
        return;
      }
      
      this.uploading = true;
      
      const timestamp = Date.now();
      const fileName = options.file.name;
      const objectKey = `${this.objectKeyPrefix}/${timestamp}_${fileName}`;
      
      const formData = new FormData();
      formData.append('file', options.file);
      formData.append('objectKey', objectKey);
      
      uploadOssFile(formData).then(res => {
        if (res.code === 200) {
          this.innerValue = res.data;
          Message.success('文件上传成功');
          this.uploadFileList = [];
          this.currentUploadFile = null;
          this.$emit('upload-success', res.data);
        } else {
          Message.error('文件上传失败：' + (res.msg || '未知错误'));
        }
      }).catch(err => {
        console.error('文件上传失败：', err);
        Message.error('文件上传失败：' + (err.message || '网络错误'));
      }).finally(() => {
        this.uploading = false;
      });
    }
  }
}
</script>

<style scoped>

</style>
